import { Content } from './styles';
export interface CardBodyProps {
  /**
   * Children prop from React.
   */
  children: React.ReactNode;
  /**
   * Styles override.
   */
  className?: string;
}

export const CardBody = ({
  className,
  children,
}: CardBodyProps): JSX.Element => {
  return (
    <Content className={className} data-testid="card-content">
      {children}
    </Content>
  );
};
